<!-- 
程式：addContractFamilyRelation.vue
功能：家庭型保單眷屬資料
作者：i94005ws02 邱琬琪
完成：2020-11-27
-->
<template>
  <div class="tab-pane pt-3 active show"  :class="{'section-loading': isLoading}">
    <div class="insurance-editor">
      <div class="col-12">
        <h4>
          <span class="text-thin">分類：</span
          >自行輸入國泰人壽保單號碼(家庭型保單眷屬資料)
        </h4>
        <h6>
          新增或編輯無記名家庭關係，「
          <span class="text-red">配偶/子女的保單資訊</span>
          」須於晚上排程更新後「
          <span class="text-red">明日才會呈現</span>
          」：
        </h6>
        <div class="panel panel-header text-bold font-20 mt-3">
          <div class="text-center">
            <span
              >主被保人：
              <avatar
                class="mr-2"
                :gender="Number(familyOwner.sex)"
                :size="20"
              />
              <span class="mr-1" style="color: #048f3a">{{
                familyOwner.name | truncate
              }}</span>
            </span>
            <span class="ml-1">
              ({{
                (parseInt(familyOwner.age) >= 0 ? familyOwner.age : "--") +
                "歲"
              }})</span
            >
          </div>
          <div class="text-center">
            <span class="ml-4">保單號碼：</span>
            <span>{{ familyOwner.plcno }}</span>
          </div>
        </div>
        <div
          class="panel panel-form text-bold border-top-0"
          style="border-radius: 0 0 8px 8px"
        >
          <div
            class="panel insurance-item pt-3"
            :class="{ noBirthday: family.birShow && !family.cop_birthday }"
            v-for="(family, i) in familyMembers"
            :key="`insure-item-${i}`"
          >
            <div class="col-1 no">{{ i + 1 }}</div>
            <div class="col-11 form-group row pl-3">
              <div class="col-3 d-flex flex-column ml-2 font-16">
                <label class="ml-1 mb-1"
                  ><span class="text-red">*</span>姓名</label
                >
                <div v-if="family.nmShow" class="form-inline row pl-2">
                  <label class="text pl-2 pr-2 text-green">{{
                    family.cop_name | truncate
                  }}</label>
                  <a class="btn btn-red" type="button" @click="deleteIntr(i)">
                    刪除
                  </a>
                </div>
                <select
                  v-else
                  class="form-control form-control-inline"
                  style="width: 160px"
                  v-model="family.cop_id"
                  :data-vv-name="`cop_id-${i}`"
                  :class="{ 'is-invalid': errors.has(`cop_id-${i}`) }"
                  v-validate="'required'"
                  @change="
                    (e) =>
                      e.target.value === 'clientSearch'
                        ? panelCliendSearchOpen(i)
                        : openNameSel(i)
                  "
                  alt="ch"
                >
                  <option value="">請選擇</option>
                  <option
                    v-for="(item, index) in toOpenNameSel(familyOwner.csid)"
                    :key="index"
                    :value="item.csidno"
                  >
                    {{ item.name | truncate }}
                  </option>
                  <option value="clientSearch">從既有客戶查詢</option>
                </select>
                <span class="text-danger" v-if="errors.has(`cop_id-${i}`)">
                  請選擇姓名
                </span>
              </div>
              <div class="col-3 d-flex flex-column">
                <label class="ml-1 mb-1"
                  ><span class="text-red">*</span>與主被保人關係</label
                >
                <select
                  class="form-control form-control-inline"
                  style="width: 160px"
                  v-model="family.cop_kind"
                  :data-vv-name="`cop_kind-${i}`"
                  :class="{ 'is-invalid': errors.has(`cop_kind-${i}`) }"
                  v-validate="'required'"
                  :disabled="!family.cop_id"
                >
                  <option value="">請選擇</option>
                  <option value="C">配偶</option>
                  <option value="0">子女</option>
                </select>
                <span class="text-danger" v-if="errors.has(`cop_kind-${i}`)">
                  請選擇與主被保人關係
                </span>
              </div>
              <div class="col-2 d-flex flex-column">
                <span class="mb-2">身分證</span>
                <span class="fw-normal">{{
                  family.cop_id
                    ? family.cop_id && family.cop_id.includes("~")
                      ? "一 一"
                      : family.cop_id
                    : "一 一"
                }}</span>
                <span class="text-danger" v-if="family.cop_id == null || family.cop_id.includes('~')">
                  身分證資訊不完整
                </span>
              </div>
              <div class="col-2 d-flex flex-column">
                <span class="ml-3 mb-2">生日</span>
                <span class="fw-normal ml-3">{{
                  family.cop_birthday | dateToROCdateFormat
                }}</span>
                <span class="text-danger" v-if="family.cop_birthday == null">
                  生日資訊不完整
                </span>
              </div>
              <div class="action text-right">
                <a
                  type="button"
                  role="button"
                  class="mt-3 btn btn-default delete-btn"
                  @click="toDeleteOpen(i)"
                  >刪除</a
                >
              </div>
              <!-- <div
                v-if="family.birShow && !family.cop_birthday"
                class="col-11 pr-0 text-right"
              >
                <span class="text-danger">
                  請先刪除無生日的眷屬，編輯生日後再加入該成員
                </span>
              </div> -->
            </div>
          </div>
          <div
            class="panel insurance-item add text-center"
            role="button"
            @click="AddInsurance()"
          >
            <div class="content text-center">
              <i class="icon-add_new text-orange"></i>
              <span class="text ml-1">新增無記名關係</span>
            </div>
          </div>
          <div class="text-danger text-bold pl-2 pt-2">
            <span>※眷屬只能選擇已填寫身分證字號與生日的成員。若資訊不完整，可前往「客戶個人資訊」進行修正</span>
          </div>
        </div>
        <div class="action mt-2 text-right">
          <a
            @click="toCancelOpen(selfPlcno)"
            type="button"
            role="button"
            class="btn btn-default"
            >取消</a
          >
          <a
            @click="toSelfPlcno()"
            type="button"
            role="button"
            class="btn btn-default"
            v-if="selfPlcno"
            >回上一步</a
          >
          <a
            :disabled="!$checkEdit(UserInfo)"
            @click="submit()"
            type="button"
            role="button"
            class="btn btn-primary"
            >確定</a
          >
        </div>
      </div>
    </div>

    <search-client-modal
      :open="clientSearchOpen"
      :custs="options.families"
      @submit="submitClient"
      @close="panelCliendSearchClose()"
    />
    <!-- P03.1.1.20 確定新增家庭型成員非家戶成員提醒-->
    <!-- <mv-info :open="mvInfoOpen" @close="closeConfirmClose()">
      <div class="text font-20" slot="content">
        <div class="mt-10">
          此保單所有的被保人都不在此家戶，<br />
          若要編輯或檢視此保單，請至被保人【{{
            familyLeader.name | truncate
          }}】的保單資訊頁面。
        </div>
      </div>
    </mv-info> -->
    <!-- P03.1.1.19 刪除提醒-->
    <mv-delete
      :open="mvDeleteOpen"
      @close="closeDeleteModal()"
      @confirm="closeDeleteModal('confirm')"
    >
      <div class="text font-cust" slot="content">
        <div class="font-20">
          您是否要刪除家庭型家戶成員
          <span class="text-green">{{ delCopName | truncate }}</span>
          ？
        </div>
      </div>
    </mv-delete>
    <!-- P03.1.1.18 取消提醒-->
    <mv-cancel
      :open="mvCancelOpen"
      @close="closeCancelModal()"
      @confirm="closeCancelModal('confirm')"
    >
      <div class="text" slot="content">
        <div class="font-20">
          請再次確認是否要取消編輯<span class="text-red"
            >「自行輸入之國壽保單」</span
          >及<span class="text-red">「家庭型保單眷屬資料」</span>?
        </div>
      </div>
    </mv-cancel>
  </div>
</template>

<script>
import FamilyMixin from "./family";
import { commonMixin as GlobalMixins } from "@/mixins/common";
import { mapGetters } from "vuex";
import SearchClientModal from "@/desktop/components/SearchClientModal";
// import mvInfo from "@/desktop/views/mv/components/mvInfo";
import mvDelete from "@/desktop/views/mv/components/mvDelete";
import mvCancel from "@/desktop/views/mv/components/mvDelete";
import HardwordMixins from "@/mixins/Hardword";
import { getAllFamily } from "@/service";
import {
  addContractFamilyRelationListMV,
  insertSelfInputPolicyNumber,
  queryFamilyRelationOfInsurance
} from "@/service";
export default {
  mixins: [FamilyMixin, GlobalMixins, HardwordMixins],
  components: {
    SearchClientModal,
    // mvInfo,
    mvDelete,
    mvCancel
  },
  data() {
    return {
      mvDeleteOpen: false, //mvDelete Modal開闔
      // mvInfoOpen: false, //mvInfoOpen Modal開闔
      mvCancelOpen: false, //mvCancelOpen Modal開闔
      clientSearchOpen: false,
      options: {},
      panelIndex: null,
      delCopName: "", //確認單一刪除成員
      selfPlcno: this.$route.query.selfPlcno, //回上一頁是否顯示
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
  },
  async mounted() {
    this.getfamilyOwner(this.familyIndex);
    await this.getFamilyOption();
    await this.getFamilyRelationOfInsurance();
  },
  methods: {
    // 被保人不可選無ID客戶
    // toOpenNameSelwithID(csid) {
    //   let rAry = this.originalFamilyList
    //     .filter((x) => !x.cop_birthday)
    //     .map((item) => item.cop_id);
    //   return this.options.families.filter(
    //     (x) =>
    //       ((x.csidno !== csid && x.birthday) ||
    //       (rAry && rAry.length > 0 && x.csidno.includes(rAry) && !x.birthday)) && (x.csidno.substring(0,1) != '~')
    //   );
    // },
    async getFamilyOption() {
      const user = JSON.parse(localStorage.userItems);
      const res = await getAllFamily(user.agidno, user.csidno);
      this.options.families = res.data;
    },
    //查詢保單無記名家庭關係
    async getFamilyRelationOfInsurance() {
      await queryFamilyRelationOfInsurance(
        this.$store.state.userInfo.id,
        this.familyOwner.csid
      ).then((result) => {
        this.familyMembers = result.body.familymembers
          ? result.body.familymembers.map((item) => ({
              ...item,
              cop_birthday: this.getChineseDateFormate(item.cop_birthday),
              nmShow: !this.isIncludes(item.cop_id),
              birShow: this.isBirShow(item.cop_birthday),
              csid: item.id
            }))
          : [];
        this.originalFamilyList = _.cloneDeep(this.familyMembers);
      });
    },
    //新增
    AddInsurance() {
      let family = this.familyMembers[this.familyMembers.length - 1];
      if (!this.familyMembers.length || this.addValidation(family)) {
        this.addFamilyMembers(this.familyOwner.csid);
      }
    },
    //確定
    async submit() {
      if(!this.$checkEdit(this.UserInfo)) return
      let isDataCorrect = true;
      if (!this.checkBirthday(this.familyMembers)) {
        isDataCorrect = false;
      }
      //判斷有無身分證
      if(!this.checkID(this.familyMembers)){
        isDataCorrect = false;
      }
      await this.checkValidate();
      //檢核「配偶」僅能有一位
      if (!this.isCopKindC(this.familyMembers)) {
        isDataCorrect = false;
      }
      // 檢核成員與主被保人重複
      if (!this.isReCorrect(this.familyMembers)) {
        isDataCorrect = false;
      }
      if (isDataCorrect) {
        this.toSave();
        //若所有家庭型家庭關係成員皆非此家戶成員,提醒視窗
        // if (
        //   this.familyMembers.length > 0 &&
        //   !this.isFamilies(this.familyMembers)
        // ) {
        //   this.toConfirmOpen();
        // } else {
        //   this.toSave();
        // }
      }
    },
    //存檔
    async toSave() {
      this.isLoading = true;
      this.inserData.insertList.push(this.familyMembers);
      this.inserData.delList.push(this.originalFamilyList);
      if (!this.isSave) {
        this.updateFamilyIndex();
      } else {
        let isDataCorrect = true;
        if (this.inserData.insertList) {
          for (let i = 0; i < this.inserData.insertList.length; i++) {
            if (
              this.inserData.insertList[i].length > 0 ||
              this.inserData.delList[i].length > 0
            ) {
              if (
                !(await this.insertFamilyRelationList(
                  this.inserData.insertList[i],
                  this.inserData.delList[i]
                ))
              ) {
                isDataCorrect = false;
                break;
              }
            }
          }
        }
        if (isDataCorrect) {
          if (this.insurances && this.insurances.length > 0) {
            this.insertSelfInput();
          } else {
            this.$toast.info({ title: `${this.selfPlcno ? "新增": "編輯"}成功` });
            this.toSelfPlcnoEditList({
              modify: this.insurances.map((x) => x.policyNumber).join(",")
            });
          }
        }
      }
    },
    //新增家庭型關係
    async insertFamilyRelationList(insertList, delList) {
      let isCorrect = false;
      await addContractFamilyRelationListMV(
        this.$store.state.userInfo.id,
        insertList,
        delList
      ).then((result) => {
        this.isLoading = false;
        if (result.header && result.header.status === "200") {
          isCorrect = true;
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: `${this.selfPlcno ? "新增": "編輯"}家庭型關係失敗` });
          }
          this.inserData.insertList = [];
          this.inserData.delList = [];
        }
      });
      return isCorrect;
    },
    //新增自行輸入國泰壽險保單
    insertSelfInput() {
      insertSelfInputPolicyNumber(
        this.$store.state.userInfo.id,
        this.insurances
      ).then((result) => {
        if (result.header && result.header.status === "200") {
          this.$toast.info({ title: "新增成功" });
          this.toSelfPlcnoEditList({
            modify: this.insurances.map((x) => x.policyNumber).join(",")
          });
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "新增自行輸入國泰壽險失敗" });
          }
        }
      });
    },
    //選擇主被保人sel後連動
    openNameSel(i) {
      let cop_id = this.familyMembers[i].cop_id;
      let reData = {};
      this.options.families.forEach((item) => {
        if (item.csidno === cop_id) {
          reData = item;
        }
      });
      this.assignFamilyMembers(i, {
        cop_name: reData.name,
        cop_birthday: reData.birthday,
        cop_kind: "",
        csid: this.familyOwner.csid,
        nmShow: false,
        birShow: this.isBirShow(reData.birthday)
      });
    },
    //選擇既有客戶確定後塞回
    submitClient(member) {
      this.assignFamilyMembers(this.panelIndex, {
        cop_id: member.id || member.ser_no,
        cop_name: member.name,
        cop_birthday: member.birthday,
        cop_kind: "",
        csid: this.familyOwner.csid,
        nmShow: true,
        birShow: this.isBirShow(member.birthday)
      });
      this.panelClose("clientSearchOpen");
    },
    //選擇既有客戶刪除
    deleteIntr(i) {
      this.assignFamilyMembers(i, {
        cop_id: "",
        cop_name: "",
        cop_birthday: "",
        cop_kind: "",
        nmShow: false,
        birShow: false
      });
    },
    //選擇既有客戶開啟
    panelCliendSearchOpen(i) {
      this.panelIndex = i;
      this.panelOpen("clientSearchOpen");
    },
    //選擇既有客戶關閉
    panelCliendSearchClose() {
      this.assignFamilyMembers(this.panelIndex, {
        cop_id: "",
        cop_name: "",
        cop_birthday: "",
        cop_kind: "",
        csid: "",
        nmShow: false,
        birShow: false
      });
      this.panelClose("clientSearchOpen");
    },
    //開啟刪除視窗
    toDeleteOpen(i) {
      this.panelIndex = i;
      this.delCopName = this.familyMembers[this.panelIndex].cop_name;
      if (this.delCopName) {
        this.panelOpen("mvDeleteOpen");
      } else {
        this.deleteInsurance(this.panelIndex);
      }
    },
    //刪除視窗
    closeDeleteModal(type) {
      this.panelClose("mvDeleteOpen");
      //確定
      if (type === "confirm") {
        this.deleteInsurance(this.panelIndex);
      }
    },
    //取消視窗
    closeCancelModal(type) {
      this.panelClose("mvCancelOpen");
      //確定
      if (type === "confirm") {
        this.$toast.info({ title: "新增失敗" });
        this.$router.push({
          name: "policyInfo-edit-list"
        });
      }
    },
    //開啟取消視窗
    toCancelOpen(selfPlcno) {
      if (!selfPlcno) {
        this.$toast.info({ title: "取消修改" });
        this.$router.push({
          name: "policyInfo-edit-list"
        });
      } else {
        this.panelOpen("mvCancelOpen");
      }
    },
    //開啟新增提醒
    // toConfirmOpen() {
    //   this.panelOpen("mvInfoOpen");
    // },
    //關閉新增提醒
    // closeConfirmClose() {
    //   this.toConfirmOpen();
    //   this.toSave();
    // },
    //畫面刪除
    deleteInsurance(i) {
      this.familyMembers.splice(i, 1);
    },
    // 檢核是否有ID
    checkID(familyMembers){
      let rAry = familyMembers
        .filter((x) => !x.cop_id||x.cop_id.substring(0,1) == '~')
        .map((item) => item.cop_name);
      if (rAry && rAry.length > 0) {
        this.setToastMsg("身分證資訊不完整");
        return false;
      }
      return true;
    }
  }
};
</script>
<style scoped>
.panel-header {
  padding: 30px 40px;
  border-radius: 8px 8px 0 0;
  justify-content: space-between;
  border: solid 0.5px #53c480;
  background-color: #e5f6ec;
}
.noBirthday {
  border: solid 0.5px red;
}
</style> 
